// @core/api/endpoints/secret/list_kv_secrets.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListKvSecretsResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List KV secrets
 * Returns all secret paths within a KV engine. Does not return secret data — use GetKvSecret to read individual secrets.
 */
export async function ListKvSecrets(
  engine_id: string,
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    prefix?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListKvSecretsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/kv/metadata`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<ListKvSecretsResponse>(requestPath, { ...requestOptions, params });
}
